import { LoadingContainer } from 'components/loadingContainer'
import { SelectEvent } from 'components/selectEvent'
import { useShowById } from 'hooks/user/useShows/useShowById'
import { useState } from 'react'
import { EventDetails } from 'types/Event'

import { Details } from './components/details'
import { Header } from './components/header'
import { Container, ContainerWrapper } from './showDetails.style'

interface Props {
    showId: string
}

export const ShowDetails = ({ showId }: Props) => {
    const { data, isLoading, error } = useShowById(showId)
    const [currentEvent, setCurrentEvent] = useState<EventDetails | null>(null)

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <Container>
                {data && (
                    <ContainerWrapper>
                        <Header title={data.name} imageId={data.cover_image.toString()} />
                        <SelectEvent showId={showId} onSelect={setCurrentEvent} />
                        {currentEvent && <Details data={data} eventDescription={currentEvent.description} />}
                    </ContainerWrapper>
                )}
            </Container>
        </LoadingContainer>
    )
}
